module.exports = __webpack_public_path__ + "img/part3-3.674761fb.png";